export const DonationImageSize = '40px';

export const DonationCardMinWidth = '250px';

export const FundraiserCardMinWidth = '300px';
